import React from 'react';

export const authRouteConfig = [
  {
    routes: [
      {
        path: '/signin',
        component: React.lazy(() => import('./Registration')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/signup',
        component: React.lazy(() => import('./Registration')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/forgot-password',
        component: React.lazy(() => import('./ForgotPassword')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/login',
        component: React.lazy(() => import('./Login')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/reset-password',
        component: React.lazy(() => import('./ResetPassword')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/signup',
        component: React.lazy(() => import('./SignUp')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/verification',
        component: React.lazy(() => import('./SignupVerification')),
      },
    ],
  }, 
  {
    routes: [
      {
        path: '/verificationSuccess',
        component: React.lazy(() => import('./SignupVerificationSuccess')),
      },
    ],
  }, 
];
